module.exports = __webpack_public_path__ + "img/hamburgini.b33bbd50.png";